module.exports = __webpack_public_path__ + "static/media/gcdef_10018.30069569.ico";